<template>
    <Card :title="$t('labels.filter_item')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6" v-for="languageAlias in languageAliasesByFilterType">
                    <FormGroup :label="`${$t('labels.name')} (${$t(`languages.${languageAlias}`)})`">
                        <Input
                            :model-value="filterItem?.names?.[languageAlias]"
                            @update:model-value="(name) => filterItem.names[languageAlias] = name"
                            :type="filter?.type === 'number' ? 'number' : 'text'"
                            :disabled="!filter?.allow_custom_values || filterItem.source_id !== null"
                        />
                        <span v-if="filter?.type === 'number' && (filter?.min_number_value !== null || filter?.max_number_value !== null)" class="form-text text-muted">
                            <span v-if="filter?.min_number_value !== null">
                                {{ $t('labels.min') }}: {{ filter?.min_number_value }}
                            </span>
                            <span v-if="filter?.max_number_value !== null">
                                <span v-if="filter?.min_number_value !== null"> - </span>
                                {{ $t('labels.max') }}: {{ filter?.max_number_value }}
                            </span>
                        </span>
                    </FormGroup>
                </div>
            </div>
        </div>
        <div v-if="!isSupplier" class="card-footer d-flex justify-content-end">
            <Button color="light" @click="remove" class="mr-2">
                {{ $t('buttons.delete') }}
            </Button>
            <Button color="indigo" @click="edit" :disabled="!filter?.allow_custom_values || filterItem.source_id !== null">
                {{ translate('buttons.edit') }}
            </Button>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";
import Button from "../../../../components/new/button/AppButton.vue";
import Alert from "../../../../components/AlertComponent.vue";

import { httpClient } from "../../../../services/HttpClient";
import MessageNotificator from "../../../../services/MessageNotificator";
import { IntegrationServiceEnum } from "../../../enums/IntegrationServiceEnum";

export default {
    name: "EditFilterItemCard",
    components: {
        Card, FormGroup, Input, Button, Alert
    },
    props: {
        integration: {
            type: Object
        }
    },
    data() {
        return {
            filterItem: {},
            filter: null
        }
    },
    methods: {
        async fetchFilter() {
            await httpClient.get(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/filters`, {
                uuids: [this.$route.params.filterUuid]
            }).then((response) => {
                this.filter = response.data.data[0]
            })
        },
        async fetchFilterItem() {
            await httpClient.get(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/filter-items`, {
                uuids: [this.$route.params.filterItemUuid]
            }).then((response) => {
                this.filterItem = response.data.data[0]
            })
        },
        async edit() {
            let requestData = {};

            if (this.filter?.type === 'number') {
                requestData.names = {}

                for (let languageAlias of this.integration.language_aliases) {
                    requestData.names[languageAlias] = this.filterItem.names[this.mainLanguageAlias] || '';
                }
            } else {
                requestData.names = this.filterItem.names
            }

            await httpClient.patch(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/filter-items/${this.$route.params.filterItemUuid}`, requestData).then(() => {
                new MessageNotificator().success(this.$t("alerts.success"))
            })
        },
        remove() {
            new MessageNotificator().confirm(this.$t("alerts.confirm_delete"), () => {
                httpClient.delete(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/filter-items/${this.$route.params.filterItemUuid}`).then(() => {
                    new MessageNotificator().success(this.$t("alerts.success"))
                    this.$router.push({name: "EditIntegrationFilterCard"})
                })
            });
        }
    },
    computed: {
        isSupplier() {
            return this.integration.service === IntegrationServiceEnum.SUPPLIER
        },
        languageAliasesByFilterType() {
            return this.filter?.type === 'number' ? [this.mainLanguageAlias] : this.integration.language_aliases;
        },
        mainLanguageAlias() {
            return this.integration.language_aliases[0];
        }
    },
    mounted() {
        this.fetchFilter()
        this.fetchFilterItem()
    }
}
</script>